/**
 * @author Harish.R <harish.r@314ecorp.com>
 * @description TextHighlighter component
 */
import React, { isValidElement } from 'react';

/**
 * reactNodeToString
 * @param reactNode
 * @returns string
 */
const reactNodeToString = (reactNode: React.ReactNode): string => {
	// https://github.com/sunknudsen/react-node-to-string/blob/master/src/index.ts
	let string = '';
	if (typeof reactNode === 'string') {
		string = reactNode;
	} else if (typeof reactNode === 'number') {
		string = reactNode?.toString();
	} else if (reactNode instanceof Array) {
		reactNode.forEach((child) => {
			string += reactNodeToString(child);
		});
	} else if (isValidElement(reactNode)) {
		// string += reactNodeToString(reactNode.props.children);
		string += reactNodeToString(reactNode.props as React.ReactNode);
	}
	return string;
};

/**
 * TextHighlighter props
 * @interface IProps
 */
interface Props {
	match: string;
	content?: string;
}

/**
 * TextHighlighter
 */
const TextHighlighter: React.FC<Props> = ({ match, content = '' }) => {
	if (!content) {
		return null;
	}

	if (!match) {
		return <div>{content}</div>;
	}

	const regex = new RegExp(match, 'gi');
	const text = (content || '').replace(/(<mark class="highlight-item">|<\/mark>)/gim, '');
	const newText = (text || '').replace(regex, '<mark class="highlight-item">$&</mark>');

	return <div dangerouslySetInnerHTML={{ __html: newText }} />;
};

export { reactNodeToString };
export default TextHighlighter;
